module.exports = __webpack_public_path__ + "static/img/toy_collections_zh.78e8d73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/toy_collections_zh.jpg
// module id = UpiX
// module chunks = 47